// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".theme--light.display-tab[data-v-5798f3b0] {\n  background-color: #f6f6f6;\n}\n.theme--dark.display-tab[data-v-5798f3b0] {\n  background-color: #273039;\n}", ""]);
// Exports
module.exports = exports;
